import { useEffect } from 'react';

export function useBodyWithoutScroll(disabled = true) {
  useEffect(() => {
    // eslint-disable-next-line functional/immutable-data
    disabled ? document.body.style.overflowY = 'hidden' : document.body.style.overflowY = '';

    // eslint-disable-next-line functional/immutable-data
    return () => { document.body.style.overflowY = ''; };
  }, [disabled]);
}
